export const CivilSubCategories = [
  {
    label: 'Corruption',
    value: 'corruption',
  },
  {
    label: 'Divorce',
    value: 'divorce',
  },
  {
    label: 'Harassment',
    value: 'harassment',
  },
  {
    label: 'Inheritance',
    value: 'Inheritance',
  },
  {
    label: 'Construction',
    value: 'Construction',
  },
  {
    label: 'Medical',
    value: 'Medical',
  },
]

export const acts = [
  'Section 5 of The Administrative Tribunals Act, 1985',
  'Section 13 of The Actuaries Act, 2006',
  'Section 2 of The Acquisition of Certain Area At Ayodhya Act, 1993',
  'Section 14 of The Academy Of Scientific And Innovative Research Act, 2011',
  'Section 20 of the Broach and Kaira Incumbered Estates Act, 1877',
  'Section 12 of the Building and other Construction Workers (Regulation of Employment and Conditions of Service)Act, 1996',
  'Section 3 of the Calcutta High Court (Extension of Jurisdiction) Act, 1953',
  'Section 9 of The Company Secretaries Act, 1980',
  'Section 26 of The Commission for Air Quality Management in National Capital Region and Adjoining Areas Act, 2021',
  'Section 15 of the Coinage Act, 2011',
  'Section 26 of THE COASTAL AQUACUL TURE AUTHORITY ACT, 2005',
  'Section 4 of The Press Council Act, 1978',
  'Section 3 of Prevention of Terrorism Repeal Act, 2004',
]

export const applications = [
  'An application for restoration of a suit',
  'An application for appointment of a court commissioner and Affidavit',
  'An application for adjournment',
  'An Non-Bailable Warrant (N.B.W.)',
  'An Application of Obtaining Signature Of Accused On Vakaltnama',
  'Format of Itervention (Assist to Public Prosecutor)',
  'Format of An Issue of Non-Bailable Warrant',
  'Extention of Interim Protection',
  'Format of An Deposition Application',
  'Format of FORM OF MEMORANDUM OF ASSOCIATION OF NON‑PROFIT MAKING COMPANY',
  'SUIT FOR SPECIAL DAMAGE BY TENANT AGAINST LANDLORD',
]

export const deedsAndPowerOfAttorney = [
  'Format of GENERAL POWER OF ATTORNEY BY A PERSON GOING ABROAD',
  'POWER OF ATTORNEY BY LANDLORDS IN FAVOUR OF DEVELOPERS',
  'POWER OF ATTORNEY FOR DEVELOPMENT OF PROPERTY BY AND IN FAVOUR OF DEVELOPERS',
  'Format of SPECIAL POWER OF ATTORNEY FOR A COURT CASE',
]

export const deedsLeaseApplications = [
  'LEASE OF A FURNISHED HOUSE FOR RESIDENTIAL PURPOSES',
  'LEASE OF PLAYGROUND TO A SCHOOL',
  'Format of Surrender of Lease',
  'Format of DEED OF RENEWAL OF LEASE',
  'Format of Form of complaint on behalf of a Banking Company',
]

export const tribunalCourtJudgments = [
  'What are the issues in the case of Jindal Stainless Limited vs Dakshin Haryana Bijli Vitran Nigam Ors on 14 November 2013? ',
  'What are the facts in the case of Lloyds Metal Energy Ltd vs Maharashtra Electricity Regulatory on 23 September 2013? ',
  'What is the case type, case number, and names of the judges in the case of M S Jsw Energy Limited vs Maharashtra State Electricity on 21 January 2013? ',
  'Who are the parties and advocates involved in the case of M S Penna Electricity Ltd vs Tamil Nadu Electricity Board Ors on 10 July 2013? ',
  'What is the summary of the case of Solar Energy Society Of India vs Gujarat Electricity Regulatory on 17 April 2013? ',
  'What are the citations referred to in the case of Tata Power Delhi Distribution Company vs 1 Delhi Electricity Regulatory on 3 July 2013? ',
  'What is the judgment or the decision or findings given by the Trial Court in the case of Reliance Infrastructure Limited vs The Maharashtra Electricity on 10 May 2013? ',
  'What is the judgment or the decision or findings given by the Appellate Tribunal Court in the case of Vedanta Aluminium Ltd Val vs Orissa Electricity Regulatory on 31 January 2013? ',
  'What is the judgment or the decision or findings given by the High Court in the case of Andhra Pradesh Ferro Alloys Producers vs Andhra Pradesh Electricity Regulatory on 11 October 2013? ',
  "What are the petitioner's arguments in the case of Dakshin Haryana Bijli Nigam Ltd vs Dlf Utilities Ltd Anr Mkvj Vjt on 17 September 2013? ",
  "What are the respondent's arguments in the case of Davangere Sugar Company vs Karnataka Electricity Regulatory on 14 November 2013?",
  'What are the keywords in the case of Yantra Esolar India Private Limited vs Gujarat Urja Vikas Nigam Ltd Ors Mkvj on 5 September 2013? ',
]

export const highCourtJudgments = [
  'What are the facts in the case of Hero Fincorp Limited vs OPC Asset Solutions Private Limited & Anr. ',
  'What are the issues in the case of Patil Rail Infrastructure Pvt. Ltd. vs Ministry of Railway & Anr. ',
  'What is the case type, case number, and names of the judgments delivered in the case of SARABJEET SINGH Vs PANCHGANGA SCHOOLS LIMITED & ORS. ',
  'Who are the parties and advocates involved in the case of N.N. Buildcon Private Limited vs HSCC (India) Private Limited & Anr. ',
  'What were the arguments presented by both sides in the case of ASIAN HOTELS (NORTH) LTD Vs SHIVAM MEDIRATTA. ',
  'What is the summary of the case of Surinder Kaur Kohli & Anr. vs MS Imperia Structures Ltd.',
  'What is the summary of the case of Tata Capital Financial Services Limited vs Naveen Kachru, Proprietor of MS South Delhi Motorcycle & Ors. ',
  'What were the judgments given by the Trial Court/Sessions Court and the High Court in the case of Tejswi Impex Pvt. Ltd. vs R-Tech Promoters Pvt. Ltd. ',
  'What are the citations referred to in the case of ASHOKA UDYOG Vs MANAGING DIRECTOR NATIONAL AGRICULTURAL COOPERATIVE MARKETING & ORS.',
  'What is the judgment or the decision or findings given by the Trial Court in the case of Deepak Chaturvedi vs Union of India and Others',
  'What is the judgement or the decision or findings given by the Sessions Court in the case of NATASHA NARWAL AND ANR. Vs DG PRISONS',
  'What is the judgment or the decision or findings given by the High Court in the case of Delhi Citizen Forum for Civil Rights vs State of NCT of Delhi and Others',
]

export const supremeCourtJudgments = [
  // 'What are the facts in the case Magic Eye Developers Pvt. Ltd versus M/s. Green Edge Infrastructure Pvt. Ltd. & Ors. Etc. (Civil Appeal Nos. 3634-37 of 2023)',
  // 'What are the issues in the case Sirajudheen versus Zeenath & Others(Civil Appeal No. 1491 of 2023 ?',
  'What are the list of Citations and other references in case of Central Bureau of Investigation Versus Kapil Wadhawan & Another.Criminal Appeal No. 391 of 2024?',
  'What is the Summary or background of the case of Dinesh Gupta Versus The State of Uttar Pradesh & Anr Criminal Appeal No(s). 214 of 2024?',
  'What is the Judgment or Decision or Findings of Trial Court in case of Rajendhiran versus Muthaiammal @ Muthayee & Ors, Civil Appeal No.37 of 2024?',
  'What is the Judgment or Decision or Findings of the Supreme Court of India in case of Satish P. Bhatt Versus The State of Maharashtra & Anr.Criminal Appeal No.42 of 2024?',
  'What are the legal Provisions or Sections included in the case of State of NCT of Delhi versus Raj Kumar @ Lovepreet @Lovely Criminal Appeal No.43 of 2024?',
  'What is the Judgment or Decision or Findings of the Supreme Court of India in case of Reliance Life Insurance Company Ltd. & Anr. Versus Jaya Wadhwani Civil Appeal No. 35 of 2024?',
  'What are the issue in the of case of Raja Gounder and Others Versus M. Sengodan and Others Civil Appeal No. 600 of 2024?',
  'What are the list of Citations and other references in case of Mariam Fasihuddin & Another. v. State by Adugodi Police Station & Another.Criminal Appeal No. 335 of 2024?',
  'What is the Judgment or Decision or Findings of the High Court in case of Gurdev Singh Bhalla Versus State of Punjab and Others Criminal Appeal No. 120 of 2024?',
  'What is the Summary or background of the case of Delhi Development Authority Versus Hello Home Education Society Civil Appeal Nos. 3659-3660 of 2023?',
  'What is the Summary or background of the case DBS Bank Limited Singapore versus Ruchi Soya Industries Limited and Another Civil Appeal No. 9133 of 2019?',
]

export const formats = [
  'Format of the Notice Landlord to Tenant for Eviction',
  'Format of the Notice for Breach of Leave and Licence Agreement',
  'Format of the Notice for Compensation for Defect in Goods',
  'Format of the Notice for Dishonour of Cheque',
  'Format of the Notice for Expulsion of a Partner or Notice under section 33 of Indian Partnership Act, 1932',
  'Format of the Notice for Insurance Claim',
  'Format of the Notice to Terminate Contract',
  'Format of the Notice for Trespass and Damage to Property',
  'Format of the Notice to Refrain from Acting as Director of the Company',
  'Format of the Notice to Claim Maintenance',
  'Format of reply notice to notice for eviction',
  'Format of the Notice for Recovery of Money and Appointment of Arbitrator',
  'Format Application for grant of probate.',
  'Format for Petition for Dissolution of Marriage',
  'Format of Suit for Medical Negligence',
]

export const listOfDocumentsForBailApplications = ['Documents for Bail Application']

export const listOfDocumentsForFilingOfDivorce = [
  'Format of List of Documents for Filing of Divorce',
]

export const copyRightAndTradeMark = [
  'Format of Application for Registration of Copyright',
  'Format of Assignment of a Registered Trade Mark',
  'Format of Complaint for Infringement of Trade Mark',
  'Format of TRADE AND MERCHANDISE MARKS ACT, 1958',
  'Format of Request to Registrar for particulars of advertisement of a mark',
]

export const motorVehicleAct = ['SUIT FOR DAMAGES FOR INJURIES CAUSED BY NEGLIGENT DRIVING']

export const petitions = [
  'Petition for Extension of Succession Certificate',
  'Petition for the Grant of Succession Certificate by Widow',
  'Suit for declaration & permanent injunction',
]

export const affidavits = [
  'Affidavit for Lost of Deed of Conveyance / Deed of Sale',
  'Format for affidavit in support of Plaint in court',
  'Draft for an Affidavit in support of Petition filed',
  'Format for grant of Probate for Lost of Will',
  'Draft for Adoption deed under Hindu Adoptiion Act(to natural gurdian / parent)',
  'Draft for Adoption deed to Orphanage under Hindu Adoptiion Act',
  'Draft for Adoption deed under Hindu Adoptiion Act(to Juvenille justice committee)',
  'Draft for adoption deed by unmarried women to widow women under Hindu adoption act',
  'Draft for adoption deed by unmarried women under Hindu adoption act',
  'Due to some medical reasons, my client was not able to file the petition, please provide me delay condonation draft',
  'Affidavit Format for injunction',
  'My client filed a case against a property owner regarding the road passed from my clients property, please provide me a injunction application',
  'Format for grant of succession certificate',
]

export const deedApplications = [
  'Format for Deed of Indemnity',
  'The grand father wishes to gift a car to my client, provide me the Format for gift deed',
  'Draft for Indemnity Bond',
  'Format Of Lease Deed for open plot of land',
  'Format Lease of Flat for Residential Purpose',
  'Format Of AGREEMENT FOR SALE',
  'Format Of DEED OF DISSOLUTION OF PARTNERSHIP',
  'Format Of DEED OF MORTGAGE ',
  'Format Of DEED OF PARTITION BETWEEN TWO CO - OWNERS',
  'Format Of Deed of Mortgage under Transfer of Property Act, 1882',
  'Draft / Format Of GENERAL POWER OF ATTORNEY',
  'Format of Leave and Licence Agreement for Commercial Purpose',
  'Format of Leave and Licence Agreement.',
  'Format Of PARTITION DEED.',
  'Format Of PARTNERSHIP DEED',
  'Format Of RELEASE DEED(Immovable Property)',
  'Format Of RELEASE DEED(Movable Property)',
  'Format Of SPECIAL POWER OF ATTORNEY',
  'Format of Suit for Cancellation of sale deed and Power of Attorney',
  'Format Of TRUST DEED',
  'Format Of Will under Indian Succession Act, 1925',
  'Format for Gift Deed(IMMOVABLE PROPERTY) under section 122 of the Transfer Of Property Act 1882',
  'Format Of AGREEMENT FOR SALE',
  'Draft for Dissolution of Partnership',
  'Draft for Suit of Dissolution of Partnership',
]

export const arbitration = [
  'Format for Arbitration Agreement under section 7(1) of the Arbitration and Conciliation Act, 1996.(For Individuals)',
  'Format for Arbitration Agreement under section 7(1) of the Arbitration and Conciliation Act, 1996.(For Company)',
  'Format for Arbitration Agreement under section 7(1) of the Arbitration and Conciliation Act, 1996.(For Partnership Firm)',
]

export const districtAndSessionsCourtApplications = [
  'Format for Application for recalling witness under section 217 ofCrPC',
  'Format for Criminal Appeal against the judgment',
  'Format for Application for service of summons by substituted service',
  'Format for Application under section 70(2) CrPC for cancellation of warrant of arrest',
  'Format for Caveat application under section 148 - A of the Civil Procedure Code',
  'Format for APPLICATION FOR CONDONATION OF DELAY',
  'Format First bail Application under section 439 of CrPC',
  'Format for Appeal',
  'Format for Appliaction for Stay',
  'Format for Criminal Appeal against the judgment',
  'Format for First Anticipatory bail Application under section 438 of CrPC',
  'Draft a complaint under Consumer Protection Act',
  'Format for In the Matter of section 439 of CrPC',
]

export const drtApplications = [
  'Application under section 151 of CPC to be filed before the honourable debt recovery tribunal for waving of the cost imposed on defendant vide order passed by this honourable tribunal',
  'Application to be filed before honourable debt recovery tribunal seeking dismissal of the application under section 19(4) of the recovery of debts due to banks and financial institutions act, 1993',
]

export const familyCourtApplications = [
  'Format for Petition for divorce by mutual consent',
  'Format for Application for permanent alimony and maintenance',
  'Format for Nullity of Marriage, under section 12 of Hindu Marriage Act 1955',
  'Format for Petition for Dissolution of Marriage on the ground of Desertion',
  'Format for Petition for divorce by on the ground of cruelty(Specimen 1)',
  'Format for Petition for divorce by on the ground of cruelty(Specimen 2)',
  'Format for Petition for judicial separation(Specimen 1 and 2)',
  'Format for Petition for Maintenance under section 125 CrPC',
  'Format for Reply for Petition for restitutional of conjugal rights(Specimen 1)',
  'Format for Reply for Petition for restitutional of conjugal rights(Specimen 2)',
  'Format for Reply for Petition for restitutional of conjugal rights(Specimen 3)',
  'Format for Reply to Injunction Application',
  'Format for Reply to the Petition for Divorce on the Ground of Cruelty',
  'Format for Petition for restitutional of conjugal rights(Specimen 1)',
  'Format for Petition on the Ground of Desertion and Adultery(Specimen 1)',
  'Format for Petition on the Ground of Desertion and Adultery(Specimen 2)',
  'Format for Petition under section 128 of the Criminal Procedure Code',
  'Format for Reply to Petition for Dissolution of Marriage on the ground of Dessertion',
  'Format for Petition under section 24 of the Hindu Marriage Act, 1955 for maintenance pendente lit',
]

export const highCourtApplications = [
  'Format for APPLICATION FOR CONDONATION OF DELAY',
  'Format for (Revision) Specimen 1.',
  'Format for (Revision) Specimen 2.',
  'Format for Appeal(Specimen 2)',
  'Format for Petition U / S 115 of Code of Civil Procedure',
  'Format for First Appeal to the High Court',
  'Format for An Appeal to the High Court',
  'Format for Caveat- High court',
]

export const writPetitions = [
  'Format for WRIT OF CERTIORARI',
  'Format for WRIT OF QUO WARRANTO',
  'Format WRIT OF HABEAS COPRUS (Specimen 1 prompt is required to be mentioned)',
  'Format for WRIT OF MANDAMUS ',
  'Format for WRIT OF PROHIBITION AND OTHER DIRECTION OR ORDER  Under Article 226 of Constitution of India. (Specimen 1)',
]

export const jmfcApplications = [
  'Format for Application for appointment of court commissioner.',
  'Format for Application for enhancement of maintenance',
  'Format for Application for enhancement of maintenance. (Specimen 1)',
  'Format for Application for taking Adjournment',
  'Format for Application Petition by Accused under section 205 of CrPC',
  'Format for Application under section 70(2) CrPC for cancellation of warrant of arrest',
  'Format for Application under section 140(No Fault Liability) of the Motor Vehicles Act, 1988 for claim',
  'Format for Caveat application under section 148 - A of the Civil Procedure Code.',
  'Draft for Complaint under section 498A',
  'Format of Defamation Case Under Section 499(Specimen 2)',
  'Draft for Suit For Compensation for Negligence',
  'Draft for Suit for damages for malicious prosecution',
  'Format Application for amendment of pleadings(Specimen 1)',
  'Format Application for grant of probate',
  'Format Application under Order XX rule 12 of Civil Procedure Code',
  'Format for First bail Application under section 436 of CrPC',
  'Format for Appeals under Consumer Protection Act(Specimen 1)',
  'Format for Application for appointment of Court Receiver(Specimen 1)',
  'Format for Application for arrest before judgment',
  'Format for Application for Attachment before Judgment',
  'Format for Application for restoration of suit under O IX rule 4 read with section 151 CPC(Specimen 1)',
  'Format for Application for temporary injunction. (Specimen 1)',
  'Format for Application for temporary injunction. (Specimen 2)',
  'Format for Application on behalf of the legal heirs of the plaintiff',
  'Format for Application to Application for restoration of appeal under Order IX rule 7 read with section 151 of Civil Procedure Code',
  'Format for Application to sue as an indigent person',
  'Format for Application under section 140(No Fault Liability) of the Motor Vehicles Act, 1988 for claim',
  'Format for Application under section 451 of CRPC',
  'Format for Application under sections 166 and 140 of the Motor Vehicles Act, 1988 for grant of compensation',
  'Format for Complaint for the offence of cheating under section 420 of IPC',
  'Format for Complaint for the offence of Defamation',
  'Format for Complaint under section 138 of the Negotiable Instruments Act',
  'Format for Consumer Complaint for Defect in Goods',
  'Format for Consumer Complaint for Deficiency in Services',
  'Format for Criminal Complaint under section 420 of Indian Penal Code and under section 8, 13 of Maharashtra Ownership of Flats Act, 1963',
  'Format for Recovery of Insurance Claim and for Compensation',
  'Format for Reply to Interim Application',
  'Format for Review Application U / S 114 Read with O XLVII of CPC.',
  'Format for Suit for Specific Performance of Contract(Specimen 1)',
  'Format for Suit for Specific Performance of Contract(Specimen 2)',
  'Format for Written statement in the suit for recovery of price for goods sold and delivered',
  'Format Of Codicil under Indian Succession Act, 1925',
  'Format of Suit against trespasser for recovery of possession and compensation',
  'Format of Suit based on Promissory note',
  'Format of Suit for Compensation for Negligence ',
  'Format of Suit for Declaration and injunction and for cancellation of Instruments',
  'Format of Suit for Declaration and Permanent Injunction(Public Nuisance).',
  'Format of Suit for Malicious Prosecution(Specimen 1 promot is required)',
  'Format of Suit for Medical Negligence',
  'Format of Suit for Nuisance Under Section 268 of Indian Penal Code 1860. ',
  'Format of Suit for Partition Specimen No. 1 ',
  'Format of Suit for Tresspass Under Section 441 of Indian Penal Code 1860 Sepcimen No. 2  ',
  'Format of Suit for Tresspass Under Section 441 of Indian Penal Code 1860 Sepcimen No. 1',
  'Format of Suit Suit for compensation for trespass',
  'ormat Petition under section 389(3) CrPC for grant of bail on conviction',
  'Format Suit for recovery of money for the Goods / equipment sold',
  'Format Under Complaint for Criminal Trespass Under Section 441 of IPC',
  'Format Under Section 494 of IPC(Marrying again during lifetime of husband or wife)',
  'Format of Suit for Evicition Under Section 16 of Maharashtra Rent Control Act 1999(Specimen 1 prompt is required to be mentioned)',
  'Format of Suit for Nuisance Under Section 268 of Indian Penal Code 1860(Specimen No. 2  prompt is required to be mentioned)',
  'Format of Suit for Partition( in JMFC prompt is required to be mentioned)',
  'Format for Writtern Statements on behalf of the defendant Suit Relating to Nuisance.',
]

export const notices = [
  'Notice by Landlord to Tenant for Eviction',
  'Notice for Breach of Leave and Licence Agreement(NOTICE By R.P.A.D.prompt is required to be mentioned)',
  'Notice for Cancellation of Tender Process and Call for Fresh Quotes',
  'Notice for Compensation for Defamation',
  'Notice for Compensation for Defect in Goods',
  'Notice for Compensation for Deficiency in Services',
  'Notice for compensation for permanent disablement and business loss',
  'Notice for Dishonour of Cheque(NOTICE By R.P.A.D.prompt is required to be mentioned)',
  'Notice for Dissolve the Marriage by Mutual Consent',
  'Notice for Expulsion of a Partner',
  'Notice for Insurance Claim',
  'Notice to Terminate Contract',
  'Notice for Recovery of Money and Appointment of Arbitrator',
  'Notice for Recovery of Price of Furniture Sold',
  'Notice for Restitution of Conjugal Rights',
  'Notice for Specific Performance of Contract',
  'Notice for Trespass and Damage to Property',
  'Notice Reply Pertaining to Divorce Case',
  'Reply notice to notice for eviction',
  'Notice to Claim Maintenance',
  'Notice to Execute Cancellation of Sale Deed and Power of Attorney and for Compensation',
  'Notice to Refrain from Acting as Director of the Company',
  'Notice to Refrain from Creating Third Party Interest in Property',
  'Notice under section 80 of CPC',
  'Notice under Section 138 of Negotiable Instruments Act',
  'Notice to the Builder from Flat Purchaser for not providing the amenities as agreed',
  'Notice to the Municipal Corporation about Building Plans',
  'Notice to the Municipal Corporation about Demolition',
  'Notice to a Wife on behalf of her Husband',
  'A Notice u/s. 138 of the Negotiable Instruments Act and Sec. 420 of the Indian Penal Code for dishonour of cheque',
  'A Notice to the Employer Bank for Releasing Dues and Claims of our Client',
  'A Notice to the Members of the Hindu Undivided Family for Selling out the Ancestral Properties Without Joining Our Client as the Necessary Party',
  'A Notice Calling upon to Effect Partition of the Ancestral Properties',
  'A Notice to the Partnership firm and its Partners for Supplying Defective Goods & Asking for Compensation - A Business/Contract Notice',
  'A Notice U/s. 164 of the Maharashtra Cooperative Housing Societies Act, 1960',
  'An Interim Reply given by the Concerned Addressee [in the Absence of his Advocate] to the Notice given by an Advocate',
  'A Notice-Reply to Matrimonial Matters-Notice-Reply on behalf of A Wife to the Notice given by her Husband’s Advocate',
  'Notice To A Lady With CloseAcquaintance WhoIs Subjecting Our Client To Physical And Mental Cruelty and Committing Such Other Criminal Acts Against Him',
  'Notice to a Legally Wedded Wife who is Subjecting Our ClientHusband to Physical and Mental Cruelty and Committing such other Criminal Acts Against Him',
  'Notice To The Landlords For Trying to Deceive our Clients in Acquiring Residential Premises on Ownership Basis in The New Building Being Constructed, as The Tenant in The Old Building',
  'A Notice Claiming Damages for Breach of Contract',
  'Notice to the Builders for the Nuisance and Illegal Acts done by his Purchasers',
  'Public Notice for property on Auction',
  'Public Notice by the advocate investigating the title of the property',
  'Public Notice',
  'Notice Under Section 106 of Transfer of Property Act To Terminate Tenancy',
  'Reply to Legal Notice under Section 138 of Negotiable Instruments - Act, 1881',
]

export const biologicalDiversity = [
  'Give section 7 of the Biological Diversity Act, 2002',
  'Give section 7 of the Biological Diversity Act, 2002',
  'Give section 6 under the Compensatory Afforestation Fund Act, 2016',
  'Section 9 of The Indian Forest Act, 1927',
  'Explain all the provisions of section 2 under the Wild Life (Protection) Act, 1991',
  'How the Compensatory Afforestation Fund  is used under Compensatory Afforestation Fund Act, 2016',
]

export const climateChangeAndPollution = [
  'Section 5 of The Air (Prevention and Control of Pollution)Act, 1981',
  'Give all the provisions of section 8 of the Water Prevention And Control of Pollution Act, 1974',
  'Give section 2 of the Environment (Protection) Act, 1986',
]

export const importantArticles = [
  'Give article 21 of Indian constitution',
  'Which article of Indian constitution deals with freedom of religion. Give the details related to this article.',
  'Which article of Indian constitution deals with freedom of speech.',
  'What are the limitations of article 19 under the Indian constitution',
  'List some constitutional bodies according to Indian constitution',
  'List some non constitutional bodies according to Indian constitution',
  'Is NITI Ayog a constitutional body',
  'Is Central Bureau of Investigation a constitutional body',
  'List the writs under article 32 of Indian constitution.',
  'How the president of India is elected.',
  'Give the preamble of Indian constitution.',
  'What comes under ordinary jurisdiction of supreme court of India.',
  'Which article of Indian constitution deals with right to education.',
]

export const partI = [
  'Article 1: India, that is Bharat.',
  'How does the Indian Constitution define the name and territory of the country in Article 1?',
  'Article 2 – Admission or establishment of new States',
  'According to the Indian Constitution, what is the procedure for the establishment of new States under Article 2?',
  'Article 3: Formation of new States',
  'Prompt: What powers does Article 3 of the Indian Constitution confer regarding the formation of new States?',
]
export const partII = [
  'Article 5: Prompt: Who is an Indian citizen at the commencement of the Constitution?',
  "Article 11: Prompt: Parliament's power to regulate citizenship?",
]

export const partIII = [
  'Article 12: Definition of the State',
  'How does Article 12 of the Indian Constitution define the term "State"?',
  'Article 14: Right to Equality',
  'What fundamental right is guaranteed under Article 14 of the Indian Constitution?',
  'Article 15: Prohibition of discrimination',
  'What types of discrimination are prohibited under Article 15 of the Indian Constitution?',
  'Article 17 – Abolition of Untouchability',
  'What does Article 17 of the Indian Constitution declare about untouchability?',
  'Article 19: Freedom of speech and expression',
  'What is the significance of freedom of speech and expression under Article 19 of the Indian Constitution?',
  'Article 21: Right to life and personal liberty',
  'How does the Indian Constitution define the scope of the right to life and personal liberty under Article 21?',
  'Article 21A: Right to education',
  'hat is the significance of Article 21A in the Indian Constitution regarding the right to education?',
  'Article 22: Protection against arrest and detention',
  'What protections does Article 22 of the Indian Constitution provide to individuals against arrest and detention?',
  'Article 24 – Child labour prohibition',
  'What is the age limit set by Article 24 of the Indian Constitution for prohibition of child labour?',
  'Article 25–28 – Freedom of religion',
  'How do Articles 25 to 28 of the Indian Constitution collectively guarantee and regulate the freedom of religion, including the rights to practice, manage, and be free from forced religious activities?',
  'Article 29–30 – Cultural and educational rights',
  'How do Articles 29 and 30 of the Indian Constitution protect the cultural identity and educational rights of minorities and ensure their right to preserve language, script, and culture?',
  'Article 32 – Right to Constitutional Remedies',
  'ow does Article 32 of the Indian Constitution empower individuals to approach the Supreme Court for enforcement of their rights?',
]

export const partIV = [
  'Article 39:',
  'What are the key Directive Principles of State Policy outlined in Article 39 of the Indian Constitution?',
  'Article 41–43 – Work, education, public assistance',
  'How do Articles 41 to 43 of the Indian Constitution guide the State in promoting the right to work, education, and providing public assistance to ensure social welfare and improve living standards?',
  'Article 44: Uniform Civil Code',
  'How does Article 44 of the Indian Constitution propose to promote national integration through a Uniform Civil Code?',
]

export const partIVa = [
  'Article 51A',
  'According to Article 51A of the Indian Constitution, what duties are citizens expected to perform to uphold the unity and integrity of India?',
]

export const partV = [
  'Article 72: President’s power to grant pardons',
  'What powers does Article 72 of the Indian Constitution grant to the President regarding pardons and clemency?',
  'Article 74 – Council of Ministers to aid President',
  'How does Article 74 of the Indian Constitution define the relationship between the President and the Council of Ministers?',
  'Article 75 – PM and Ministers',
  'What does Article 75 of the Indian Constitution say about the appointment of the Prime Minister and other Ministers?',
  'Article 76: Attorney General of India',
  'According to Article 76, what are the functions and duties of the Attorney General of India?',
  'Article 79–122 – Parliament',
  'How do Articles 79 to 122 of the Indian Constitution define the structure, composition, powers, procedures, and functioning of the Parliament of India, including the roles of the President, Lok Sabha, and Rajya Sabha?',
]

export const partVI = [
  'Article 161: Governor’s power to grant pardons',
  'What powers does Article 161 of the Indian Constitution grant to the Governor in terms of pardoning and commuting sentences?',
]

export const partIX = [
  'Article 243:',
  'What does Article 243 of the Indian Constitution signify in the context of Panchayati Raj and local self-governance?',
  'Article 168–212 – State Legislature',
  'How do Articles 168 to 212 of the Indian Constitution explain the setup, powers, and working of the State Legislature, including the roles of the Governor, the State Legislative Assembly, and the Legislative Council?',
]

export const partX = [
  'Article 244',
  'What is the purpose of Article 244 of the Indian Constitution in relation to Scheduled and Tribal Areas?',
]

export const partXII = [
  'Article 265:',
  'No tax shall be levied or collected except by authority of law.',
]

export const economicOffences = [
  'Give all provisions of section 9 under the fugitive economic offenders act 2018.',
  'What is Section 3 of The Prevention of Money Laundering Act, 2002',
  'Which section of  The Prevention of Money Laundering Act, 2002 deals with the Procedure and manner of furnishing information',
  'Give name of bodies or committees formed under Prevention of Corruption Act, 1988 ',
  'What is the composition of Central Vigilance Commission',
]

export const partXIII = [
  'Article 301:',
  'What does Article 301 of the Indian Constitution say about the freedom of trade, commerce, and intercourse in India?',
]

export const partXIV = [
  'Article 311',
  'What protections does Article 311 of the Indian Constitution provide to civil servants against dismissal, removal, or reduction in rank?]',
]

export const partXV = [
  'Article 324',
  'What powers and responsibilities are given to the Election Commission of India under Article 324 of the Indian Constitution?',
]

export const partXVIII = [
  'Article 352: National Emergency',
  'According to Article 352 of the Indian Constitution, what happens to the powers of the Centre and the States during a National Emergency?',
  'Article 356: President’s Rule',
  'How does Article 356 of the Indian Constitution ensure that the State government functions are taken over during President’s Rule?',
  'Article 360: Financial Emergency',
  'What safeguards exist in Article 360 of the Indian Constitution to regulate the declaration and continuation of a Financial Emergency?',
]

export const partXIX = [
  'Article 361 – President and Governor immunity',
  'What protections does Article 361 of the Indian Constitution provide to the President and Governors from legal proceedings?',
]

export const partXX = [
  'Article 368 – Procedure for amendment',
  'According to Article 368 of the Indian Constitution, who has the authority to initiate the amendment process?',
]

export const partXXI = [
  'Article 370 – (Now abrogated) Special status of J&K.',
  'What was the significance of Article 370 in granting special status to Jammu & Kashmir under the Indian Constitution?',
  'Article 371–371J – Special provisions for certain states',
  'How do Articles 371 to 371J of the Indian Constitution provide special provisions and safeguards for the administration, development, and cultural protection of certain states in India?',
]

export const partXXII = [
  'Article 393–395',
  'How do Articles 393 to 395 help keep laws, courts, and officials working smoothly when India became a Republic?',
]

export const civilProcedure = [
  'Section 2 of The Code of Civil Procedure, 1908',
  'Which section deals with the Costs for causing delay under the Code of Civil Procedure.',
  'What are the Powers of the Court in executing transferred decree under  The Code of Civil Procedure.',
  'Which section deals with  Arrest and detention under The Code of Civil Procedure, 1908.',
  'What are the powers of magistrate under civil procedure code.',
]

export const familyLaw = [
  'Give section 3 of Indian Succession Act.',
  'Give section 4 of Protection of Women from Domestic Violence Act',
  'section 6 of Births, Deaths and Marriages Registration Act, 1886',
  'Give  section 10 under The Hindu Adoptions and Maintenance Act, 1956',
]

export const divorce = [
  'Explain Section 4 of The Divorce Act 1869',
  'Give section 2 of Muslim Women Protection of Rights on Divorce Act, 1986',
  'Give Section 10 of The Divorce Act 1869',
  'What are the procedures of divorce under the Divorce act 1869.',
  'What is the section of mutual divorce under Hindu Marraige Act',
  'What does Restitution of Conjugal Rights expalins and under which section it is briefly explained ',
]

export const marriage = [
  'Give Section  2 of The Hindu Marriage Act, 1955 ',
  'Which section deals with Marriage Officers under The Special Marriage Act.',
  'Give all provisions of Section 8 of The Special Marriage Act.',
  'Which section deals with Solemnization of marriage under The Foreign Marriage act',
  'Give section 16 of Christian Marriage Act, 1872.',
  'Section 2 of The Prohibition of Child Marriage Act, 2006',
  'Give section 27 of Special Marriage Act, 1872.',
]

export const adoption = [
  'What is Section 2 of The Hindu Adoptions and Maintenance Act.',
  'Give Section 2 of the Juvenile Justice Care and Protection of Children act.',
  'What is Section 12 of The Hindu Adoptions and Maintenance Act.',
  'Give the provision of maintenance under the Hindu Adoptions and Maintenance Act.',
]

export const companiesBankruptcyAndInsolvency = [
  'Section 2 The Recovery of Debts and Bankruptcy Act, 1993',
  'Give all provisions of Section 3 of The Insolvency and Bankruptcy Code, 2016',
  'Give Section 4 of The Sick Industrial Companies act',
  'Is there any body or committee to be established under Insolvency and Bankruptcy act',
  'What are the powers of National Company Law Tribunal (NCLT) under Companies Act, 2013.',
  'How a company should be registered under Companies Act, 2013.',
]

export const contract = [
  'Give all provisions of Section 2 of The Indian Contract Act.',
  'Which section deals with Undue influence under The Indian Contract Act',
  'Give section 9 of Contract Labour (Regulation and Abolition) Act, 1970',
  'Give section 2 of The Securities Contracts Act, 1956',
]

export const bankingAndFinance = [
  'Section 2 of Reserve Bank of India Act, 1934',
  'Give all provisions of section 11 under Payment and Settlement Systems Act, 2007',
  'Explain section 10 of Banking Regulation Act, 1949',
  'Section 4 of The Securities and Exchange Board of India Act, 1992',
  'Give the powers of RBI under the Banking Regulation Act, 1949',
]

export const companiesLaw = [
  'Explain all provisions of section 12 under Companies Act, 2013',
  'Give all the provisions of section 9 under the Insolvency and Bankruptcy Code, 2016',
  'Give all the provisions of section 9 under the Insolvency and Bankruptcy Code, 2016',
  'Which section of the Competition Act, 2002 deals with Abuse of dominant position?',
  'Which section of the Competition Act, 2002 deals with  establishment of Commission.',
]

export const industrialRelation = [
  'Give section 5 of Trade Unions Act, 1926',
  'Give the important sections of Industrial Disputes Act, 1947',
  'What is the definition of factory according to the Factories Act, 1948',
  'Is there any body or committee established under Industrial Disputes act 1947',
  'Is there any body or committee established under Industrial Disputes act 1947',
]

export const labourAndEmploymentLaws = [
  'What should be minimum wage under Minimum Wages Act, 1948',
  'Give important sections of Sexual Harassment of Women at Workplace 2013',
  'Give all the provisions of Section 13A of Payment of Wages Act, 1936',
  'Pension Fund Regulatory and Development Authority Act, 2013',
  'Which establishments come under Occupational Safety, Health and Working Conditions ',
]

export const roadSafety = [
  'Explain Section 185 of the Motor Vehicle Act.',
  'What are the penalty for drunken driving',
  'Which section deals with Restrictions on the granting of learners licences under Motor Vehicles Act.',
  'Which section deals with Renewal of driving licences under Motor Vehicle Act.',
  'What is the penalty for drving without helmet',
  'What is the penalty for driving without license',
  'What is the penalty for jumping the signal',
]

export const sexualOffensesAndHarrashmentAct = [
  'Give Section 6 of Sexual Harassment of Women at Workplace Act, 2013',
  'Give all provisions of section 5 of Sexual Harassment of Women at Workplace Act, 2013',
  'What was Criminal Law (Amendment) Act, 2013',
  'Is there any body or committee under Sexual Harassment of Women at Workplace Act, 2013',
  'Which section of Indian penal code deals with eve teasing ',
  'Which section talks about the outrage modesty of a women and under which act does this section is charged',
]

export const murder = [
  'Which section of Indian Penal Code deals with  murder.',
  'Which section is related to drunken driving under Motor vehicle Act',
  'Which section deals with Culpable homicide under the Indian Penal Code.',
  'What are  the punishments for murder according to Indian Penal Code',

  'In how many days, a chargesheet is supposed to be filed by Police machinery in the offence of murder under Indian Penal Code',
]

export const fraudAndTheft = [
  'Give section 210 of Indian Penal Code',
  'Give provisions of section 379 under Indian Penal Code.',
  'Which section deals with using a forged document as genuine under the Indian Penal Code?',

  'Give all the provisions of Section 471 of the Indian Penal Code ',
]

export const criminalProcedure = [
  'Section 2 of The Code of Criminal Procedure 1973',
  'Section 4 of The Code of Criminal Procedure 1973',
  'Which section deals with Classes of Criminal Courts under The Code of Criminal Procedure 1973',
  'What are the powers of magistrate under the criminal procedure code.',
  'What are the powers of Sessions Judge under the criminal procedure code.',
  'What is the section of regular bail application under code of criminal procedure',
  'What is the section of Anticipatory bail application under code of criminal procedure',
  'What does section 167 (2) of code of criminal procedure expalins',
  'What does section 205 of code of criminal procedure expalins',
  'What does section 317 of code of criminal procedure expalins',
]

export const incomeTax = [
  'Give section 80D of Income Tax Act 1961.',
  'Which section deals with Deduction in respect of donations to certain funds, charitable institutions under Income Tax Act 1961',
  'Explain section 4 of Income Tax Act, 1961.',
  'What are the punishments of not paying income tax  under Income Tax Act 1961.',
  'Give important provisions of Black Money Undisclosed Foreign Income and Assets and Imposition of Tax Act',
]

export const indirectTax = [
  'Give Section 1 of The Goods and Services Tax (Compensation to States) Act, 2017',
  'Section 3 of The Goods and Services Tax (Compensation to States) Act, 2017',
  'Section 4 of Integrated Goods and Services Tax Act, 2017',
  'Explain all provisions of section 9 under the Central Goods and Services Tax Act, 2017',
  'Is there any body established under the Central Goods and Services Tax Act, 2017',
  'Who are the members of Goods and Services tax council',
]

export const caseBased = [
  'I was in possession of marijuana when police office caught me. now that officer is blackmailing me and is demanding 5000 rupees to let go the matter. How can i protect myself',
  'A vendor given me a check. When I submited in bank it got bounced. What remedies do I have.',
  'A police officer is harrashing me. What remedies do I have.',
  'An advocate is charging more fees to win the case. what can I do.',
]

export const domesticLegislationForInternationalLawAndConvention = [
  'Which act was passed to give affect to United Nations Convention on the Law of the Sea.',
  'Give Article 93 of The Geneva Conventions Act, 1960',
  'Give article 253 of Indian constitution.',
  'Which article of Indian constitution give power for implementing any treaty, agreement, or convention',
  'Which international body replaced the General Agreement on Tariffs and Trade (GATT)',
  'Which agreement is related with the establishment of WTO',
]

export const patentTrademarkAndGI = [
  'List important provisions under the Patents Act, 1970',
  'Give important provisions of section 5 under the Designs Act, 2000',
  'Give all the provisions of section 9 under the Bureau of Indian Standards Act, 2016',
  'Which section deals with the Prohibition of manufacture and sale of certain drugs and cosmetics under Drugs and Cosmetics Act, 1940',
  'List some items declared as geographical indicators under the Geographical Indications of Goods act 2002',
  'Give section 10 of Designs Act, 2000',
]

// ==========================================================================
export const CivilJudgesCategories = [
  {
    label: 'Dhananjaya Y. Chandrachud',
    value: 'dhananjaya y. chandrachud',
  },
  {
    label: 'Sanjay Kishan Kaul',
    value: 'sanjay kishan kaul',
  },
  {
    label: 'Sanjiv Khanna',
    value: 'sanjiv khanna',
  },
  {
    label: 'Bhushan Ramkrishna Gavai',
    value: 'bhushan ramkrishna gavai',
  },
]

export const CivilCourtsCategories = [
  {
    label: 'Supreme Court',
    value: 'supreme court',
  },
  {
    label: 'High Courts',
    value: 'high courts',
  },
  {
    label: 'District Courts',
    value: 'district courts',
  },
  {
    label: 'Lok Adalats/Village Courts',
    value: 'lok adalats',
  },
  {
    label: 'Tribunals',
    value: 'tribunals',
  },
]

export const CriminalSubCategories = [
  {
    label: 'Murder',
    value: 'murder',
  },
  {
    label: 'Dacoity',
    value: 'dacoity',
  },
  {
    label: 'Fraud',
    value: 'fraud',
  },
]

export const legalMaxims = [
  'Ab Initio',
  'Actionable per se',
  'Actio personalis moritur cum persona',
  'Actori incumbit onus probandi',
  'Actus me invito factus non est mens actus',
  'Actus non facit reum nisi mens sit rea',
  'Actus reus',
  'Actus Reus Non Facit Reum Nisi Mens Sit Rea',
  'Ad hoc',
  'Alibi',
  'Amicus Curiae',
  'Ante Litem Motam',
  'Assentio mentium',
  'Audi alteram partem',
  'Bona fide',
  'Bona vacantia',
  'Boni judicis est ampliare jurisdictionem',
  'Caveat',
  'Caveat actor',
  'Caveat emptor',
  'Caveat venditor',
  'Certiorari',
  'Communis hostis omnium',
  'Corpus',
  'Corpus delicti',
  'Crimen trahit personam',
  'Damnum sine injuria',
  'De facto',
  'De jure',
  'De minimis',
  'De Minimis Non Curat Lex',
  'De novo',
  'Dictum',
  'Doli capax',
  'Doli incapax',
  'Detinue',
  'Donatio mortis causa',
  'Estoppel',
  'Ex gratia',
  'Ex officio',
  'Ex parte',
  'Ex post facto',
  'Falsus in uno falsus in omnibus',
  'Fatum',
  'Factum probandum',
  'Factum probans',
  'Fraus est celare fraudem',
  'Functus officio',
  'Furiosi nulla voluntas est',
  'Furious absentis loco est',
  'Furiosis furore suo puiner',
  'Furiosis nulla voluntas est',
  'Habeas corpus',
  'Ignorantia facit doth excusat, Ignorance juris non-excusat',
  'Ignorantia juris non excusat',
  'Injuria sine damnum',
  'Ipso facto',
  'In promptu',
  'In lieu of',
  'In personam',
  'Innuendo',
  'In status quo',
  'Inter alia',
  'Inter vivos',
  'Interest Reipublicae Ut Sit Finis Litium',
  'Jus cogens or ius cogens',
  'Jus in personam',
  'Jus in rem',
  'Jus naturale',
  'Jus Necessitatis',
  'Jus non scriptum',
  'Jus scriptum',
  'Jus',
  'Justitia nemini neganda est',
  'Jus soli',
  'Jus sanguins',
  'Lex Fori',
  'Lex non a rege est violanda',
  'Locus standi',
  'Mala fide',
  'Malum in se or Mala in se (plural)',
  'Malum prohibitum',
  'Mandamus',
  'Mens rea',
  'Misnomer',
  'Modus operandi',
  'Modus Vivendi ',
  'Mutatis Mutandis',
  'Nemo bis punitur pro eodem delicto',
  'Nemo debet bis vexari pro una et eadem causa',
  'Nemo debet esse judex in propria causa or Nemo judex in causa sua or Nemo judex in sua causa',
  'Nemo moriturus praesumitur mentire',
  'Nemo Potest esse tenens et dominus',
  'Nolle prosequi',
  'Novation',
  'Nullum crimen sine lege, nulla poena sine lege',
  'Nunc pro tunc',
  'Non Sequitur',
  'Obiter dictum',
  'Onus probandi',
  'Pacta Sunt Servanda',
  'Pari passu',
  'Particeps criminis',
  'Per curiam (decision or opinion)',
  'Per se',
  'Persona non grata',
  'Potior est conditio possidentis',
  'Prima facie',
  'Alimony',
  'Palimony',
  'Per curiam',
  'Per incuriam',
  'Quantum meruit',
  'Qui facit per alium, facit per se',
  'Qui peccat ebrius luat sobrius',
  'Quid pro quo ',
  'Qui sentit commodum, sentire debet et onus',
  'Quo warranto',
  'Quod necessitas non habet legem or Necessitas non habet legem',
  'Ratio decidendi',
  'Respondeat superior',
  'Res ipsa loquitor',
  'Res Judicata',
  'Res Judicata Pro Veritate Accipitur',
  'Rex non protest peccare',
  'Salus populi est suprema lex or Suprema lex salus populi',
  'Status quo',
  'Sine die',
  'Sine qua non',
  'Suo Motu',
  'Ubi jus ibi remedium',
  'Veto',
  'Vice versa',
  'Vis major',
  'Volenti non fit injuria',
  'Vox populi',
  'Waiver',
]
// export const Judjements = [
//   {
//     label:
//       'What are the facts in the case Magic Eye Developers Pvt. Ltd versus M/s. Green Edge Infrastructure Pvt. Ltd. & Ors. Etc. (Civil Appeal Nos. 3634-37 of 2023)',
//     value:
//       'What are the facts in the case Magic Eye Developers Pvt. Ltd versus M/s. Green Edge Infrastructure Pvt. Ltd. & Ors. Etc. (Civil Appeal Nos. 3634-37 of 2023)',
//   },
//   {
//     label:
//       'What are the issues in the case Sirajudheen versus Zeenath & Others(Civil Appeal No. 1491 of 2023 ?',
//     value:
//       'What are the issues in the case Sirajudheen versus Zeenath & Others(Civil Appeal No. 1491 of 2023 ?',
//   },
//   {
//     label:
//       'What are the list of Citations and other references in case of Central Bureau of Investigation Versus Kapil Wadhawan & Another.Criminal Appeal No. 391 of 2024?',
//     value:
//       'What are the list of Citations and other references in case of Central Bureau of Investigation Versus Kapil Wadhawan & Another.Criminal Appeal No. 391 of 2024?',
//   },
//   {
//     label:
//       'What is the Summary or background of the case of Dinesh Gupta Versus The State of Uttar Pradesh & Anr Criminal Appeal No(s). 214 of 2024?',
//     value:
//       'What is the Summary or background of the case of Dinesh Gupta Versus The State of Uttar Pradesh & Anr Criminal Appeal No(s). 214 of 2024?',
//   },
//   {
//     label:
//       'What is the Judgment or Decision or Findings of Trial Court in case of Rajendhiran versus Muthaiammal @ Muthayee & Ors, Civil Appeal No.37 of 2024?',
//     value:
//       'What is the Judgment or Decision or Findings of Trial Court in case of Rajendhiran versus Muthaiammal @ Muthayee & Ors, Civil Appeal No.37 of 2024?',
//   },
//   {
//     label:
//       'What is the Judgment or Decision or Findings of the Supreme Court of India in case of Satish P. Bhatt Versus The State of Maharashtra & Anr.Criminal Appeal No.42 of 2024?',
//     value:
//       'What is the Judgment or Decision or Findings of the Supreme Court of India in case of Satish P. Bhatt Versus The State of Maharashtra & Anr.Criminal Appeal No.42 of 2024?',
//   },
//   {
//     label:
//       'What are the legal Provisions or Sections included in the case of State of NCT of Delhi versus Raj Kumar @ Lovepreet @Lovely Criminal Appeal No.43 of 2024?',
//     value:
//       'What are the legal Provisions or Sections included in the case of State of NCT of Delhi versus Raj Kumar @ Lovepreet @Lovely Criminal Appeal No.43 of 2024?',
//   },
//   {
//     label:
//       'What is the Judgment or Decision or Findings of the Supreme Court of India in case of Reliance Life Insurance Company Ltd. & Anr. Versus Jaya Wadhwani Civil Appeal No. 35 of 2024?',
//     value:
//       'What is the Judgment or Decision or Findings of the Supreme Court of India in case of Reliance Life Insurance Company Ltd. & Anr. Versus Jaya Wadhwani Civil Appeal No. 35 of 2024?',
//   },
//   {
//     label:
//       'What are the issue in the of case of Raja Gounder and Others Versus M. Sengodan and Others Civil Appeal No. 600 of 2024?',
//     value:
//       'What are the issue in the of case of Raja Gounder and Others Versus M. Sengodan and Others Civil Appeal No. 600 of 2024?',
//   },
//   {
//     label:
//       'What are the list of Citations and other references in case of Mariam Fasihuddin & Another. v. State by Adugodi Police Station & Another.Criminal Appeal No. 335 of 2024?',
//     value:
//       'What are the list of Citations and other references in case of Mariam Fasihuddin & Another. v. State by Adugodi Police Station & Another.Criminal Appeal No. 335 of 2024?',
//   },
//   {
//     label:
//       'What is the Judgment or Decision or Findings of the High Court in case of Gurdev Singh Bhalla Versus State of Punjab and Others Criminal Appeal No. 120 of 2024?',
//     value:
//       'What is the Judgment or Decision or Findings of the High Court in case of Gurdev Singh Bhalla Versus State of Punjab and Others Criminal Appeal No. 120 of 2024?',
//   },
//   {
//     label:
//       'What is the Summary or background of the case of Delhi Development Authority Versus Hello Home Education Society Civil Appeal Nos. 3659-3660 of 2023?',
//     value:
//       'What is the Summary or background of the case of Delhi Development Authority Versus Hello Home Education Society Civil Appeal Nos. 3659-3660 of 2023?',
//   },
//   {
//     label:
//       'What is the Summary or background of the case DBS Bank Limited Singapore versus Ruchi Soya Industries Limited and Another Civil Appeal No. 9133 of 2019?',
//     value:
//       'What is the Summary or background of the case DBS Bank Limited Singapore versus Ruchi Soya Industries Limited and Another Civil Appeal No. 9133 of 2019?',
//   },
// ]

export const criminalComplaint = [
  'Criminal Complaint U/ss. 323, 324, 504 & 506 R/w. Sec. 34 of the Indian Penal Code',
  'Criminal Complaint U/s. 323 & 504 R/w. Sec. 34 of The Indian Penal Code',
  'Criminal Complaint U/s. 494 R/W Sec. 34 of The Indian Penal Code',
  'Criminal Complaint U/s. 500 of The Indian Penal Code',
  'A Criminal Complaint U/Ss. 193, 468, 503, 504 & 506 R/W Sec. 34 of The Indian Penal Code',
  'A Complaint in The Labour Court',
  'Complaint in The Consumer Forum',
  'Complaint for Consumer Protection',
  'Bail Application In Case of Section 307 of Indian Penal Code, 1860 (Attempt to Murder)',
  'Bail Application before the Judicial Magistrate Court in A Pending Case',
  'Bail Application before the High Court',
  'Criminal Appeal',
  'An Application U/s. 30 (2) of The Interim Relief Act 1971',
  'Application under Section 12 of the Protection of Women from Domestic Violence Act, 2005 (43 of 2005)',
  'An Affidavit in Support of The Complaint and Application',
  'An Affidavit in Support of The Complaint',
]

export const CriminalJudgesCategories = [
  {
    label: 'Bhushan Ramkrishna Gavai',
    value: 'bhushan ramkrishna gavai',
  },
  {
    label: 'Sanjiv Khanna',
    value: 'sanjiv khanna',
  },
]

export const CriminalCourtsCategories = [
  {
    label: 'Supreme Court',
    value: 'supreme court',
  },
  {
    label: 'High Courts',
    value: 'high courts',
  },
  {
    label: 'Courts of Session',
    value: 'courts of session',
  },
  {
    label: 'Judicial and Executive Magistrates',
    value: 'judicial and executive magistrates',
  },
]

export const BankruptcySubCategories = [
  {
    label: 'Insolvency',
    value: 'insolvency',
  },
  {
    label: 'Dissolution',
    value: 'dissolution',
  },
  {
    label: 'Restructuring',
    value: 'restructuring',
  },
]

export const BankruptcyVariableCategories = [
  {
    label: 'XYZ',
    value: 'xyz',
  },
  {
    label: 'GGG',
    value: 'ggg',
  },
]

export const BankruptcyJudgesCategories = [
  {
    label: 'Mr. Justice Aniruddha Bose',
    value: 'aniruddha bose',
  },
  {
    label: ' Mr. Justice Ajjikuttira Somaiah Bopanna',
    value: 'ajjikuttira somaiah bopanna',
  },
]

export const BankruptcyCourtsCategories = [
  {
    label: ' National Company Law Tribunal (NCLT)',
    value: 'NCLT',
  },
  {
    label: ' National Company Law Appellate  Tribunal (NCLAT)',
    value: 'NCLAT',
  },
  {
    label: 'Insolvency and Bankruptcy Board of India (IBBI)',
    value: 'IBBI',
  },
]

export const andhraPradesh = [
  'Alluri Sitharama Raju',
  'Anakapalli',
  'Parvathipuram Manyam',
  'Srikakulam',
  'Visakhapatnam',
  'Vizianagaram',
  'Anantapur',
  'Annamayya',
  'Chittoor',
  'YSR (Kadapa)',
  'Kurnool',
  'Nandyal',
  'Sri Sathya Sai',
  'Tirupati',
  'Bapatla',
  'Dr. B. R. Ambedkar Konaseema',
  'East Godavari',
  'Eluru',
  'Guntur',
  'Kakinada',
  'Krishna',
  'NTR',
  'Palnadu',
  'Prakasam',
  'Sri Potti Sriramulu Nellore',
  'West Godavari',
]

export const arunachalPradesh = [
  'ANJAW',
  'Itanagar',
  'Changlang',
  'Dibang Valley',
  'East Kameng',
  'East Siang',
  'Kamle',
  'Kra Daadi',
  'Kurung Kumey',
  'Leparada',
  'Lohit',
  'Longding',
  'Lower Dibang Valley',
  'Lower Siang',
  'Lower Subansiri',
  'Namsai ',
  'Pakke Kessan',
  'Papum Pare ',
  'Shi Yomi',
  'Siang',
  'Tawang',
  'Tirap ',
  'Upper Siang',
  'Upper Subansiri',
  'West Kameng ',
  'West Siang',
]

export const Assam = [
  'Bajali',
  'Baksa',
  'Barpeta',
  'Bongaigaon',
  'Cachar',
  'Charaideo',
  'Chirang',
  'Darrang',
  'Dhemaji',
  'Dhubri',
  'Dibrugarh',
  'Dima Hasao',
  'Goalpara',
  'Golaghat',
  'Hailakandi',
  'Jorhat',
  'Kamrup',
  'Kamrup Metropolitan',
  'Karbi Anglong',
  'Karimganj',
  'Kokrajhar',
  'Lakhimpur',
  'Majuli',
  'Morigaon',
  'Nagaon',
  'Nalbari',
  'Sivasagar',
  'Sonitpur',
  'South Salmara-Mankachar',
  'Tinsukia',
  'Udalguri',
  'West Karbi Anglong',
]

export const Bihar = [
  'Araria',
  'Arwal',
  'Aurangabad',
  'Banka',
  'Begusarai',
  'Bhagalpur',
  'Bhojpur',
  'Buxar',
  'Darbhanga',
  'Gaya',
  'Gopalganj',
  'Jamui',
  'Jehanabad',
  'Kaimur (Bhabua)',
  'Katihar',
  'Khagaria',
  'Kishanganj',
  'Lakhisarai',
  'Madhepura',
  'Madhubani',
  'Munger',
  'Muzaffarpur',
  'Nalanda',
  'Nawada',
  'Pashchim Champaran',
  'Patna',
  'Purbi Champaran',
  'Purnia',
  'Rohtas',
  'Saharsa',
  'Samastipur',
  'Saran',
  'Sheikhpura',
  'Sheohar',
  'Sitamarhi',
  'Siwan',
  'Supaul',
  'Vaishali',
]

export const Chhattisgarh = [
  'Balod',
  'Balodabazar-Bhatapara',
  'Balrampur-Ramanujganj',
  'Bastar',
  'Bemetara',
  'Bijapur',
  'Bilaspur',
  'Dakshin Bastar Dantewada',
  'Dhamtari',
  'Durg',
  'Gariyaband',
  'Gaurela-Pendra-Marwahi',
  'Janjgir-Champa',
  'Jashpur',
  'Kabeerdham',
  'Khairagarh-Chhuikhadan-Ganda',
  'Kondagaon',
  'Korba',
  'Korea',
  'Mahasamund',
  'Manendragarh-Chirmiri-Bharatpur(M C B)',
  'Mohla-Manpur-Ambagarh Chouki',
  'Mungeli',
  'Narayanpur',
  'Raigarh',
  'Raipur',
  'Rajnandgaon',
  'Sakt',
  'Sarangarh-Bilaigar',
  'Sukma',
  'Surajpur',
  'Surguja',
  'Uttar Bastar Kanker',
]

export const Goa = ['Goa']

export const Gujarat = [
  'Ahmedabad',
  'Amreli',
  'Anand',
  'Arvalli',
  'Banas Kantha',
  'Bharuch',
  'Bhavnagar',
  'Botad',
  'Chhotaudepur',
  'Dahod',
  'Dangs',
  'Devbhumi Dwarka',
  'Gandhinagar',
  'Gir Somnath',
  'Jamnagar',
  'Junagadh',
  'Kachchh',
  'Kheda',
  'Mahesana',
  'Mahisagar',
  'Morbi',
  'Narmada',
  'Navsari',
  'Panch Mahals',
  'Patan',
  'Porbandar',
  'Rajkot',
  'Sabar Kantha',
  'Surat',
  'Surendranagar',
  'Tapi',
  'Vadodara',
  'Valsad',
]

export const Haryana = [
  'Ambala',
  'Bhiwani',
  'Charkhi Dadri',
  'Faridabad',
  'Fatehabad',
  'Gurugram',
  'Hisar',
  'Jhajjar',
  'Jind',
  'Kaithal',
  'Karnal',
  'Kurukshetra',
  'Mahendragarh',
  'Nuh',
  'Palwal',
  'Panchkula',
  'Panipat',
  'Rewari',
  'Rohtak',
  'Sirsa',
  'Sonipat',
  'Yamunanagar',
]

export const himachalPradesh = [
  'Bilaspur',
  'Chamba',
  'Hamirpur',
  'Kangra',
  'Kinnaur',
  'Kullu',
  'Lahaul And Spiti',
  'Mandi',
  'Shimla',
  'Sirmaur',
  'Solan',
  'Una',
]

export const Jharkhand = [
  'Bokaro',
  'Chatra',
  'Deoghar',
  'Dhanbad',
  'Dumka',
  'East Singhbum',
  'Garhwa',
  'Giridih',
  'Godda',
  'Gumla',
  'Hazaribagh',
  'Jamtara',
  'Khunti',
  'Koderma',
  'Latehar',
  'Lohardaga',
  'Pakur',
  'Palamu',
  'Ramgarh',
  'Ranchi',
  'Sahebganj',
  'Saraikela Kharsawan',
  'Simdega',
  'West Singhbhum',
]

export const Karnataka = [
  'Bagalkote',
  'Ballari',
  'Belagavi',
  'Bengaluru Rural',
  'Bengaluru Urban',
  'Bidar',
  'Chamarajanagar',
  'Chikkaballapura',
  'Chikkamagaluru',
  'Chitradurga',
  'Dakshina Kannada',
  'Davanagere',
  'Dharwad',
  'Gadag',
  'Hassan',
  'Haveri',
  'Kalaburagi',
  'Kodagu',
  'Kolar',
  'Koppal',
  'Mandya',
  'Mysuru',
  'Raichur',
  'Ramanagara',
  'Shivamogga',
  'Tumakuru',
  'Udupi',
  'Uttara Kannada',
  'Vijayanagara',
  'Vijayapura',
  'Yadgir',
]

export const Kerala = [
  'Alappuzha',
  'Ernakulam',
  'Idukki',
  'Kannur',
  'Kasaragod',
  'Kollam',
  'Kottayam',
  'Kozhikode',
  'Malappuram',
  'Palakkad',
  'Pathanamthitta',
  'Thiruvananthapuram',
  'Thrissur',
  'Wayanad',
]

export const madhyaPradesh = [
  'Agar-Malwa',
  'Alirajpur',
  'Anuppur',
  'Ashoknagar',
  'Balaghat',
  'Barwani',
  'Betul',
  'Bhind',
  'Bhopal',
  'Burhanpur',
  'Chhatarpur',
  'Chhindwara',
  'Damoh',
  'Datia',
  'Dewas',
  'Dhar',
  'Dindori',
  'Guna',
  'Gwalior',
  'Harda',
  'Indore',
  'Jabalpur',
  'Jhabua',
  'Katni',
  'Khandwa (East Nimar)',
  'Khargone (West Nimar)',
  'MAUGANJ',
  'Maiha',
  'Mandla',
  'Mandsaur',
  'Morena',
  'Narmadapuram',
  'Narsimhapur',
  'Neemuch',
  'Niwari',
  'Pandhurn',
  'Panna',
  'Raisen',
  'Rajgarh',
  'Ratlam',
  'Rewa',
  'Sagar',
  'Satna',
  'Sehore',
  'Seoni',
  'Shahdol',
  'Shajapur',
  'Sheopur',
  'Shivpuri',
  'Sidhi',
  'Singrauli',
  'Tikamgarh',
  'Ujjain',
  'Umaria',
  'Vidisha',
]

export const Maharashtra = [
  'Ahilyanagar',
  'Akola',
  'Amravati',
  'Beed',
  'Bhandara',
  'Buldhana',
  'Chandrapur',
  'Chhatrapati Sambhajinagar',
  'Dharashiv',
  'Dhule',
  'Gadchiroli',
  'Gondia',
  'Hingoli',
  'Jalgaon',
  'Jalna',
  'Kolhapur',
  'Latur',
  'Mumbai',
  'Mumbai Suburban',
  'Nagpur',
  'Nanded',
  'Nandurbar',
  'Nashik',
  'Palghar',
  'Parbhani',
  'Pune',
  'Raigad',
  'Ratnagiri',
  'Sangli',
  'Satara',
  'Sindhudurg',
  'Solapur',
  'Thane',
  'Wardha',
  'Washim',
  'Yavatmal',
]

export const Manipur = [
  'Bishnupur',
  'Chandel',
  'Churachandpur',
  'Imphal East',
  'Imphal West',
  'Jiriba',
  'Kakching',
  'Kamjong',
  'Kangpokpi',
  'None',
  'Pherzawl',
  'Senapati',
  'Tamenglong',
  'Tengnoupal',
  'Thoubal',
  'Ukhrul',
]

export const Meghalaya = [
  'East Garo Hills',
  'East Jaintia Hills',
  'East Khasi Hills',
  'Eastern West Khasi Hills',
  'North Garo Hills',
  'Ri Bhoi',
  'South Garo Hills',
  'South West Garo Hills',
  'South West Khasi Hills',
  'West Garo Hills',
  'West Jaintia Hills',
  'West Khasi Hills',
]

export const Mizoram = [
  'Aizawl',
  'Champhai',
  'Hnahthia',
  'Khawzaw',
  'Kolasib',
  'Lawngtlai',
  'Lunglei',
  'Mamit',
  'Saitua',
  'Serchhip',
  'Siaha',
]

export const Nagaland = [
  'Chumoukedima',
  'Dimapur',
  'Kiphire',
  'Kohima',
  'Longleng',
  'Mokokchung',
  'Mon',
  'Niulan',
  'Noklak',
  'Peren',
  'Phek',
  'Shamator',
  'Tseminyu',
  'Tuensang',
  'Wokha',
  'Zunheboto',
]

export const Odisha = [
  'Anugul',
  'Balangir',
  'Baleshwar',
  'Bargarh',
  'Bhadrak',
  'Boudh',
  'Cuttack',
  'Deogarh',
  'Dhenkanal',
  'Gajapati',
  'Ganjam',
  'Jagatsinghapur',
  'Jajapur',
  'Jharsuguda',
  'Kalahandi',
  'Kandhamal',
  'Kendrapara',
  'Kendujhar',
  'Khordha',
  'Koraput',
  'Malkangiri',
  'Mayurbhanj',
  'Nabarangpur',
  'Nayagarh',
  'Nuapada',
  'Puri',
  'Rayagada',
  'Sambalpur',
  'Sonepur',
  'Sundargarh',
]

export const Punjab = [
  'Amritsar',
  'Barnala',
  'Bathinda',
  'Faridkot',
  'Fatehgarh Sahib',
  'Fazilka',
  'Ferozepur',
  'Gurdaspur',
  'Hoshiarpur',
  'Jalandhar',
  'Kapurthala',
  'Ludhiana',
  'Malerkotla',
  'Mansa',
  'Moga',
  'Pathankot',
  'Patiala',
  'Rupnagar',
  'S.A.S Nagar',
  'Sangrur',
  'Shahid Bhagat Singh Nagar',
  'Sri Muktsar Sahib',
  'Tarn Taran',
]

export const Rajasthan = [
  'Ajmer',
  'Alwar',
  'Anupgarh',
  'Balotra',
  'Banswara',
  'Baran',
  'Barmer',
  'Beawar',
  'Bharatpur',
  'Bhilwara',
  'Bikaner',
  'Bundi',
  'Chittorgarh',
  'Churu',
  'Dausa',
  'Deeg',
  'Dholpur',
  'Didwana-Kuchama',
  'Dudu',
  'Dungarpur',
  'Ganganagar',
  'Gangapurcity',
  'Hanumangarh',
  'Jaipur',
  'Jaipur (Gramin',
  'Jaisalmer',
  'Jalore',
  'Jhalawar',
  'Jhunjhunu',
  'Jodhpur',
  'Jodhpur (Gramin',
  'Karauli',
  'Kekri',
  'Khairthal-Tijara',
  'Kota',
  'Kotputli-Behror',
  'Nagaur',
  'Neem Ka Thana',
  'Pali',
  'Phalodi',
  'Pratapgarh',
  'Rajsamand',
  'Salumbar',
  'Sanchore',
  'Sawai Madhopur',
  'Shahpura',
  'Sikar',
  'Sirohi',
  'Tonk',
  'Udaipur',
]

export const Sikkim = ['Gangtok', 'Gyalshing', 'Mangan ', 'Namchi', 'Pakyong', 'Soreng ']

export const tamilNadu = [
  'Ariyalur',
  'Chengalpattu',
  'Chennai',
  'Coimbatore',
  'Cuddalore',
  'Dharmapuri',
  'Dindigul',
  'Erode',
  'Kallakurichi',
  'Kancheepuram',
  'Kanniyakumari',
  'Karur',
  'Krishnagiri',
  'Madurai',
  'Mayiladuthurai',
  'Nagapattinam',
  'Namakkal',
  'Perambalur',
  'Pudukkottai',
  'Ramanathapuram',
  'Ranipe',
  'Salem',
  'Sivaganga',
  'Tenkasi',
  'Thanjavur',
  'The Nilgiris',
  'Theni',
  'Thiruvallur',
  'Thiruvarur',
  'Thoothukkudi',
  'Tiruchirappalli',
  'Tirunelveli',
  'Tirupathur',
  'Tiruppur',
  'Tiruvannamalai',
  'Vellore',
  'Viluppuram',
  'Virudhunagar',
]

export const Telangana = [
  'Adilabad',
  'Bhadradri Kothagudem',
  'Hanumakonda',
  'Hyderabad',
  'Jagitial',
  'Jangoan',
  'Jayashankar Bhupalapally',
  'Jogulamba Gadwal',
  'Kamareddy',
  'Karimnagar',
  'Khammam',
  'Kumuram Bheem Asifabad',
  'Mahabubabad',
  'Mahabubnagar',
  'Mancherial',
  'Medak',
  'Medchal Malkajgiri',
  'Mulugu',
  'Nagarkurnool',
  'Nalgonda',
  'Narayanpet',
  'Nirmal',
  'Nizamabad',
  'Peddapalli',
  'Rajanna Sircilla',
  'Ranga Reddy',
  'Sangareddy',
  'Siddipet',
  'Suryapet',
  'Vikarabad',
  'Wanaparthy',
  'Warangal',
  'Yadadri Bhuvanagiri',
]

export const Tripura = [
  'Dhalai',
  'Gomati',
  'Khowai',
  'North Tripura',
  'Sepahijala',
  'South Tripura',
  'Unakoti',
  'West Tripura',
]

export const Uttarakhand = [
  'Almora',
  'Bageshwar',
  'Chamoli',
  'Champawat',
  'Dehradun',
  'Haridwar',
  'Nainital',
  'Pauri Garhwal',
  'Pithoragarh',
  'Rudra Prayag',
  'Tehri Garhwal',
  'Udam Singh Nagar',
  'Uttar Kashi',
]

export const UttarPradesh = [
  'Agra',
  'Aligarh',
  'Ambedkar Nagar',
  'Amethi',
  'Amroha',
  'Auraiya',
  'Ayodhya',
  'Azamgarh',
  'Baghpat',
  'Bahraich',
  'Ballia',
  'Balrampur',
  'Banda',
  'Bara Banki',
  'Bareilly',
  'Basti',
  'Bhadohi',
  'Bijnor',
  'Budaun',
  'Bulandshahr',
  'Chandauli',
  'Chitrakoot',
  'Deoria',
  'Etah',
  'Etawah',
  'Farrukhabad',
  'Fatehpur',
  'Firozabad',
  'Gautam Buddha Nagar',
  'Ghaziabad',
  'Ghazipur',
  'Gonda',
  'Gorakhpur',
  'Hamirpur',
  'Hapur',
  'Hardoi',
  'Hathras',
  'Jalaun',
  'Jaunpur',
  'Jhansi',
  'Kannauj',
  'Kanpur Dehat',
  'Kanpur Nagar',
  'Kasganj',
  'Kaushambi',
  'Kheri',
  'Kushinagar',
  'Lalitpur',
  'Lucknow',
  'Mahoba',
  'Mahrajganj',
  'Mainpuri',
  'Mathura',
  'Mau',
  'Meerut',
  'Mirzapur',
  'Moradabad',
  'Muzaffarnagar',
  'Pilibhit',
  'Pratapgarh',
  'Prayagraj',
  'Rae Bareli',
  'Rampur',
  'Saharanpur',
  'Sambhal',
  'Sant Kabir Nagar',
  'Shahjahanpur',
  'Shamli',
  'Shrawasti',
  'Siddharthnagar',
  'Sitapur',
  'Sonbhadra',
  'Sultanpur',
  'Unnao',
  'Varanasi',
]

export const WestBengal = [
  'Alipurduar',
  'Bankura',
  'Birbhum',
  'Cooch Behar',
  'Dakshin Dinajpur',
  'Darjeeling',
  'Hooghly',
  'Howrah',
  'Jalpaiguri',
  'Jhargram',
  'Kalimpong',
  'Kolkat',
  'Malda',
  'Murshidabad',
  'Nadia',
  'North 24 Parganas',
  'Paschim Bardhaman',
  'Paschim Medinipur',
  'Purba Bardhaman',
  'Purba Medinipur',
  'Purulia',
  'South 24 Parganas',
  'Uttar Dinajpur',
]
